import { SkillDefinition } from "./types";
import type { CombatEvent } from "../../state/combatEvents";

/**
 * Computes the damage multiplier for the Attack skill based on level.
 * Level 1: 1.0x, Level 2: 1.25x, Level 3: 1.5x, Level 4: 1.75x, Level 5: 2.0x
 */
const getAttackMultiplier = (level: number): number => 1 + (level - 1) * 0.25;

export const attackSkill = {
  id: "attack",
  name: "Attack",
  description: "A basic strike. Upgrades increase damage.",
  requiresTarget: true,
  use: ({ targetIndex, skillLevel, applyDamageToEnemy, getPlayerAttack, hasValidTarget }) => {
    if (!hasValidTarget(targetIndex)) {
      return [];
    }

    const events: CombatEvent[] = [];
    const baseDamage = getPlayerAttack();
    const multiplier = getAttackMultiplier(skillLevel);
    const finalDamage = Math.floor(baseDamage * multiplier);
    const damage = applyDamageToEnemy(targetIndex!, finalDamage);
    if (damage !== undefined) {
      events.push({
        kind: "playerAttack" as const,
        targetIndex: targetIndex!,
        amount: damage,
        ...(damage <= 0 ? { blocked: true } : {}),
      });
    }
    return events;
  },
} satisfies SkillDefinition<"attack">;
